// NOTE: It is necessary to add any new prebuilt color classes to this array or tailwind will purge them!
export const presetColors = [
  `bg-tags-silver`,
  `bg-tags-gray`,
  `bg-tags-salmon`,
  `bg-tags-orange`,
  `bg-tags-yellow`,
  `bg-tags-green`,
  `bg-tags-blue`,
  `bg-tags-purple`,
  `bg-tags-pink`,
  `bg-tags-red`,
  `bg-tags-amber`,
]
